<script>
    export default {
        props: {
            smartFilter: Object,
        },
        methods: {
            async selectObject() {
                this.$store.commit('SMART_FILTER_DATA_EDIT_SET', this.smartFilter);
                this.$store.dispatch('CHECK_SMART_FILTER_EDIT');
                this.$store.commit('IS_SHOW_SMART_FILTER_EDIT', true)
            }
        }
    }
</script>


<template>
    <li>
        <div
            class="blur_white cursor_pointer_label"
            @click="selectObject"
        >
            <label>[{{ smartFilter['id'] }}]</label>
            <label
                class="ml_5"
            >{{ smartFilter['name'] }}</label>
        </div>
    </li>
</template>